var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"armenians-loader",attrs:{"role":"status","aria-label":_vm.ariaLabel || undefined}},[_c('div',{ref:"animation",staticClass:"armenians-loader__animation"})])
}
var staticRenderFns = []

export { render, staticRenderFns }